import React, { useEffect, useState, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { loadNatalChart } from '../lib/chartStorage';
import { computeReportStructure } from '../lib/reportUtils';
import ReportContent from '../components/chart/ReportContent';
import './ChartReportPrintPage.css';

const ChartReportPrintPage = () => {
  const [data, setData] = useState(undefined);
  const hasAutoPrinted = useRef(false);

  useEffect(() => {
    const stored = loadNatalChart();
    if (stored?.chartResult?.chartModel) {
      setData(stored);
    } else {
      setData(null);
    }
  }, []);

  useEffect(() => {
    if (data?.chartResult?.chartModel && !hasAutoPrinted.current) {
      hasAutoPrinted.current = true;
      const timer = setTimeout(() => {
        window.print();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [data]);

  if (data === undefined) {
    return (
      <div className="chart-report-print-page chart-report-print-loading">
        <p>Preparing report for print…</p>
      </div>
    );
  }

  if (data === null || !data.chartResult?.chartModel) {
    return <Navigate to="/chart" replace />;
  }

  const { chartResult, meta } = data;
  const chart = chartResult.chartModel;
  const wheelData = chartResult.wheelData;
  const structure = computeReportStructure(chart.planets);
  const sun = chart.planets.find((p) => p.key === 'sun');
  const moon = chart.planets.find((p) => p.key === 'moon');
  const rising = chartResult.angles?.asc;
  const mc = chartResult.angles?.mc;

  return (
    <div className="chart-report-print-page">
      <ReportContent
        chartResult={chartResult}
        meta={meta}
        chart={chart}
        wheelData={wheelData}
        structure={structure}
        sun={sun}
        moon={moon}
        rising={rising}
        mc={mc}
        variant="print"
      />
    </div>
  );
};

export default ChartReportPrintPage;
